"use server";

import { auth } from "@/auth";
import type { ActionResult } from "@/types/server-action";
import { z } from "zod";
import { validateParams } from "@/lib/utils";
import {
  buildFundingDraftUpdate,
  saveDraftFundingDataSchema,
} from "@/lib/schemas/cat/funding-draft";
import { updateDraftAfterStepSave } from "@/lib/cat/draft-step-save";
import {
  buildDraftLockHolder,
  DraftLockDeniedError,
} from "@/lib/cat/draft-lock";
import type { Draft } from "@/prisma/generated/client";

export async function saveDraftData(
  params: z.infer<typeof saveDraftFundingDataSchema>,
): Promise<ActionResult<Draft>> {
  try {
    const session = await auth();
    if (!session?.user?.id) {
      return { success: false, message: "Non authentifié." };
    }
    const clientdata = validateParams(saveDraftFundingDataSchema, params);
    const { id } = clientdata;
    const data = buildFundingDraftUpdate(clientdata);

    const sessionKvps = session.data?.kvps?.current?.identifier ?? String(id);

    const lockHolder = buildDraftLockHolder(session.user);

    const savedDraft = await updateDraftAfterStepSave({
      draftId: id,
      stepId: "leasing_financing",
      userId: lockHolder.userId,
      userName: lockHolder.userName,
      kvps: sessionKvps,
      data,
    });
    return { success: true, data: savedDraft };
  } catch (error) {
    console.error(error);

    if (error instanceof DraftLockDeniedError) {
      return { success: false, message: error.message };
    }

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
